/* global axios */
// NOTICE: KAPTION-INTEGRATION
// sales-pipeline.API.1 — pipeline config + server-side stage moves.
import ApiClient from './ApiClient';

class KaptionSalesPipelineAPI extends ApiClient {
  constructor() {
    super('kaption_sales_pipeline', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  save(config) {
    return axios.put(this.url, config);
  }

  createDefault(names) {
    return axios.post(`${this.url}/create_default`, { names });
  }

  move({ conversationId, toStageId, pipelineId }) {
    return axios.post(`${this.url}/move`, {
      conversation_id: conversationId,
      to_stage_id: toStageId,
      pipeline_id: pipelineId,
    });
  }
}

export default new KaptionSalesPipelineAPI();
